import axiosInstance from '../instance/AxiosInstance';

export const staffViewEffect = (id) => {
  return axiosInstance
    .get(`/staffs/getstaff?staff_id=${id}`)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      throw error;
    });
};

export const staffAddEffect = async (payload) => {
  try {
    const response = await axiosInstance.post('/staffs/insert', payload);

    return response.data; //here data use because response come inside data
  } catch (error) {
    console.log('AddStafferror', handleApiError(error));

    throw error.response?.data || 'Failed to Add Staff';
  }
};
export const staffUpdateEffect = async (payload) => {
  try {
    const response = await axiosInstance.put(
      `/staffs/updatestaff/${payload.id}`,
      payload
    );

    return response.data;
  } catch (error) {
    throw error.response?.data || 'Failed to Update Staff';
  }
};

export const staffViewAllEffect = async (payload) => {
  try {
    const response = await axiosInstance.get(
      `/staffs/list?pagination_required=true&pagesize=${payload.pagesize}&pageNo=${payload.pageNo}`
    );

    return response.data;
  } catch (error) {
    console.log('staffresponse', error);
    throw error.response?.data?.message || 'Failed to Update Staff';
  }
};
export const staffFetchAllEffect = async () => {
  try {
    const response = await axiosInstance.get(`/staffs/list`);
    console.log('resoponse', response);
    return response.data;
  } catch (error) {
    console.log('error', error);
    throw error.response?.data?.message || 'Failed to Update Staff';
  }
};

export const staffDeleteEffect = async (payload) => {
  try {
    const response = await axiosInstance.delete(
      `/staffs/deletestaff/${payload}`
    );

    return response;
  } catch (error) {
    throw new Error(error.response?.data?.message || 'Failed to Delete Staff');
  }
};
export const handleApiError = (error) => {
  console.log('Full Error Object:', error);
  if (error.response) {
    const errorData = error.response.data || {};
    const errorFields = errorData.errorFields || {};
    return {
      statusCode: error.response.status,
      email: errorFields.email || null,
      phone: errorFields.phone || null,
      contact: errorFields.contact || null,
      additionalErrors: errorFields,
      message: errorData.message || 'Unknown error occurred.',
    };
  } else if (error.request) {
    console.log('Request without response:', error.request);
    return {
      statusCode: null,
      message: 'No response received from the server. Please try again later.',
    };
  } else {
    console.log('Unexpected error:', error);
    return {
      statusCode: null,
      message: error.message || 'An unexpected error occurred.',
    };
  }
};
